import { baseURL } from '../apiService/apiService'

export const getImageAbsolutePath = (path) => baseURL + path
